import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { bindMenu, bindTrigger } from 'material-ui-popup-state';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined'
import { Checkbox, styled } from "@mui/material";
import { useCallback } from "react";
import { useDataManager } from "./DataManager";
import { xor, upperFirst } from "lodash-es";
import { SPEND_COLUMNS } from "components/PerformanceTable/utils";

const MenuCheckbox = styled(Checkbox)(() => ({
  width: '20px',
  height: '20px',
}))

function getColumnVariants(column: string, showAdjusted: boolean): string[] {
  const variants: string[] = [];

  if (showAdjusted && SPEND_COLUMNS.includes(column)) {
    variants.push(`adjusted${upperFirst(column)}`);
  }

  return variants;
}

export function getVisibleColumns(
  showAdjusted: boolean,
  visibleColumns: string[] = []
): string[] {
  const prefixesToFilterOut: string[] = [];

  if (!showAdjusted) prefixesToFilterOut.push('adjusted');

  const baseColumns = visibleColumns.filter(col =>
    !prefixesToFilterOut.some(prefix => col.startsWith(prefix)) &&
    !prefixesToFilterOut.some(prefix => col.startsWith(`customMetrics:${prefix}`))
  );

  const variantColumns = baseColumns.flatMap(col =>
    getColumnVariants(col, showAdjusted)
  );

  return [...baseColumns, ...variantColumns];
}

export default function ColumnSettingMenu({menuPopupState, filterPopupState, showSettingsMenu, dispatch, column}) {
  const dataManager = useDataManager()

  const handleToggleSubtotal = useCallback(column => _event => {
    const subtotalColumns = xor(dataManager.tableSettings.subtotalColumns, [column.field])
    dataManager.setTableSettings({...dataManager.tableSettings, subtotalColumns: subtotalColumns})
  }, [dataManager])

  const handleToggleAdjusted = useCallback(() => {
    const toggledShowAdjusted = !dataManager.tableSettings.showAdjusted
    const updatedVisibleColumns = getVisibleColumns(toggledShowAdjusted, dataManager.tableSettings.visibleColumns)

    dataManager.setTableSettings({...dataManager.tableSettings, visibleColumns: updatedVisibleColumns, showAdjusted: toggledShowAdjusted})
  }, [dataManager])

  return (
    <Menu
      {...bindMenu(menuPopupState)}
      open={showSettingsMenu}
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      transformOrigin={{vertical: 'top', horizontal: 'right'}}
      disableAutoFocusItem
      sx={{
        '.MuiTypography-root': {fontSize: '14px'},
        '.MuiPaper-root': {width: 200}
      }}
    >
      {column.groupable &&
        <MenuItem onClick={handleToggleSubtotal(column)}>
          <ListItemIcon>
            <MenuCheckbox checked={dataManager.tableSettings.subtotalColumns.includes(column.field)} disableRipple/>
          </ListItemIcon>
          <ListItemText>Subtotal</ListItemText>
        </MenuItem>
      }
      {SPEND_COLUMNS.includes(column.field) &&
        <MenuItem onClick={() => handleToggleAdjusted()}>
          <ListItemIcon>
            <MenuCheckbox checked={dataManager.tableSettings.showAdjusted} disableRipple/>
          </ListItemIcon>
          <ListItemText>View Adjusted Spend</ListItemText>
        </MenuItem>
      }
      <MenuItem {...bindTrigger(filterPopupState)} onClick={() => dispatch({ type: 'SHOW_FILTER_OPTIONS' })}>
        <ListItemIcon>
          <FilterAltOutlinedIcon fontSize='small' />
        </ListItemIcon>
        <ListItemText>Filter column</ListItemText>
      </MenuItem>
    </Menu>
  )
}
